import { useState } from "react";

export function useUserId() {
	return useState(() => {
		let id = sessionStorage.getItem("user-id");
		if (!id) {
			id = crypto.randomUUID();
			sessionStorage.setItem("user-id", id);
		}
		return id;
	})[0];
}
